<template>
    <div>
        <UserNav />
            <div class="h2 py-3 text-center">งานขอคุณ</div>
            <div class="px-3">
                <div class="card shadow-lg border border-0">
                    <div class="card-body">
                        <Noti />
                    </div>
                </div>
            </div>
        <FooterMenu :activeTab="activeTab" @menu-click="tabChange"/>
    </div>
</template>

<script>
import FooterMenu from '@/components/FooterMenu.vue'
import UserNav from '@/components/UserNav.vue';
import Noti from '@/components/Noti.vue';

export default {
    name: 'UserView',
    components: {
        FooterMenu,UserNav,Noti
    },
    data(){
        return {
            activeTab: 'user'
        }
    },
    mounted () {
        // alert('งานขอคุณ')
    },
    methods: {
        tabChange(tab) {
            this.$router.push('/'+tab).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
        }
        
    }

}

</script>